import { render, staticRenderFns } from "./LeftWrap3.vue?vue&type=template&id=35843350&scoped=true"
import script from "./LeftWrap3.vue?vue&type=script&lang=js"
export * from "./LeftWrap3.vue?vue&type=script&lang=js"
import style0 from "./LeftWrap3.vue?vue&type=style&index=0&id=35843350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35843350",
  null
  
)

export default component.exports